import React from 'react';

export const formatCurrency = (value) => {
  const numberValue = parseFloat(value);
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
  }).format(numberValue);
};

export const formatDateForHTMLInput = (dateString) => {
  if (!dateString) return '';
  const [month, day, year] = dateString.split(/[-\/]/);
  return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
};

export const formatDateForInput = (dateString) => {
  if (!dateString) return '';
  const [month, day, year] = dateString.split('-');
  return `${month}/${day}/${year}`;
};

export const getFieldValue = (field, isNameField = false) => {
  return field?.FinalValue?.Value || (isNameField ? '' : '-');
};

// Determine cell styling based on status and filters
export const getCellColorAndMessage = (status, alertFilters, message, elevateRequiredFields) => {
  const colorClasses = {
    'Error': 'error-cell',
    'Warning': 'warning-cell',
    'Invalid' : 'invalid-cell'
  };

  const textColorClasses = {
    'Error': 'error-message',
    'Warning': 'warning-message',
    'Invalid' : 'invalid-message'
  };

  let colorClass = '';
  let textColorClass = '';
  let cellMessage = message || '';

  // Always color text based on status
  if (status === 'Error') {
    textColorClass = textColorClasses['Error'];
  } else if (status === 'Warning') {
    textColorClass = textColorClasses['Warning'];
  } else if (status === 'Invalid'){
    textColorClass = elevateRequiredFields ? textColorClasses['Error'] : textColorClasses['Invalid'];
  }

  // Only apply background color when filters are active
  if (alertFilters.includes('Error') && status === 'Error') {
    colorClass = colorClasses['Error'];
  } else if (alertFilters.includes('Warning') && status === 'Warning') {
    colorClass = colorClasses['Warning'];
  } else if (alertFilters.includes('Invalid') && status === 'Invalid'){
    colorClass = elevateRequiredFields ? colorClasses['Error'] : colorClasses['Invalid'];
  }

  return { colorClass, textColorClass, message: cellMessage };
};

// Constants
export const TABLE_HEADERS = [
  { name: <div style={{ whiteSpace: 'pre-line' }}>LAST{'\n'}NAME *</div>, field: 'LastName' },
  { name: <div style={{ whiteSpace: 'pre-line' }}>FIRST{'\n'}NAME *</div>, field: 'FirstName' },
  { name: 'HIRE DATE *', field: 'DateOfHire' },
  { name: <div style={{ whiteSpace: 'pre-line' }}>DATE OF{'\n'}BIRTH *</div>, field: 'DateOfBirth' },
  { name: 'SSN *', field: 'SSN' },
  { name: <div style={{ whiteSpace: 'pre-line' }}>TERMINATION{'\n'}DATE</div>, field: 'DateOfTermination' },
  { name: <div style={{ whiteSpace: 'pre-line' }}>HOURS{'\n'}WORKED *</div>, field: 'HoursWorked' },
  { name: <div style={{ whiteSpace: 'pre-line' }}>GROSS{'\n'}COMP. *</div>, field: 'GrossCompensation' },
  { name: <div style={{ whiteSpace: 'pre-line' }}>PRE-TAX{'\n'}CONTRIBUTIONS</div>, field: 'DeferALS' },
  { name: <div style={{ whiteSpace: 'pre-line' }}>ROTH{'\n'}CONTRIBUTIONS</div>, field: 'ParticipantRoth' },
  { name: <div style={{ whiteSpace: 'pre-line' }}>EMPLOYER{'\n'}MATCH</div>, field: 'CompanyMatch' },
  { name: <div style={{ whiteSpace: 'pre-line' }}>PROFIT{'\n'}SHARING</div>, field: 'CompanyProfitSharing' },
  { name: 'ROLLOVER', field: 'RollOver' },
  { name: <div style={{ whiteSpace: 'pre-line' }}>LOAN{'\n'}PAYMENT</div>, field: 'AnnualLoanPayment' },
];

export const FIELDS_TO_NORMALIZE = [
  'GrossCompensation',
  'HoursWorked',
  'DeferALS',
  'ParticipantRoth',
  'CompanyMatch',
  'CompanyProfitSharing',
  'AnnualLoanPayment',
  'RollOver'
];

export const COLOR_CLASSES = {
  'Error': 'error-cell',
  'Warning': 'warning-cell',
  'Invalid' : 'invalid-cell'
};

export const TEXT_COLOR_CLASSES = {
  'Error': 'error-message',
  'Warning': 'warning-message',
  'Invalid' : 'invalid-message'
};

export const MAX_VISIBLE_PAGES = 5;